export default __webpack_public_path__ + "static/media/Diviner's Armbands of the Kingmaker.0ea7e360.jpg";